<template>
  <section>
    <!--Tabela de dados-->
    <el-table stripe size=small ref="tableData" :data=listaNfe v-loading=listLoading @row-click="rowClicked"
      @expand-change="controlExpand" empty-text=' ' :row-style=rowStyle style="width: 100%"
      :row-key="row => row.nfeChave" :expand-row-keys="expandRowKeys">
      <el-table-column type="expand" width="14">
        <template slot-scope="documentos">
          <el-table size=mini :data=eventosNfe v-loading=eveListLoading empty-text=' ' style="width: 100%;">
            <el-table-column prop="dataEvento" label="Data Evento">
            </el-table-column>
            <el-table-column prop="nfeProtocolo" label="Protocolo">
            </el-table-column>
            <el-table-column prop="descricaoEvento" label="Evento">
            </el-table-column>
            <el-table-column label="Ações" width="270" align=left>
              <template slot-scope="eventos">
                <el-tooltip class="item" effect="dark" content="Download do XML do evento" placement="bottom">
                  <el-button plain type="primary" size=mini :loading=formRule.xmlLoading
                    @click.native.prevent="downloadXmlNfe(eventos.row)">XML</el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Gerar DANFE da NF-e" placement="bottom">
                  <el-button plain type="primary" size=mini :loading=formRule.danfeLoading
                    v-if="eventos.row.nfeEvento === '110100' && nfeSituacao === 'N'"
                    @click.native.prevent="downloadDanfeNfe(eventos.row)">DANFE</el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" content="Enviar NF-e por e-mail" placement="bottom">
                  <el-button plain type="primary" size=mini
                    v-if="eventos.row.nfeEvento === '110100' && nfeSituacao === 'N'"
                    @click.native="showDialogEmail(eventos.row)">E-MAIL</el-button>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column label="Tipo" width="83" align=center>
        <template slot-scope="scope">
          <el-tag size='mini' disable-transitions>{{ formatTipo(scope.row, scope.row.tipoDocto) }}</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="dataEvento" label="Emissão" width="82" align=center>
      </el-table-column>
      <el-table-column prop="nfeChaveFormat" label="Chave" width="358">
      </el-table-column>
      <!-- <el-table-column prop="emitenteDestinatario" :label="descrEmitDest" width="368"> -->
      <el-table-column prop="emitenteDestinatario" :label="descrEmitDest">
      </el-table-column>
      <el-table-column prop="nfeNro" label="Número" width="95" align=right>
      </el-table-column>
      <el-table-column prop="valorDocumento" label="Valor" width="115" align=right>
      </el-table-column>
      <el-table-column label="Situação" width="90" align=center>
        <template slot-scope="scope">
          <el-tag size='mini' type="success" disable-transitions
            v-if="scope.row.nfeSituacao === 'N'">Autorizada</el-tag>
          <el-tag size='mini' type="danger" disable-transitions v-if="scope.row.nfeSituacao === 'C'">Cancelada</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-col :span="24" class="toolbar">
      <el-pagination layout="sizes, prev, pager, next, total" @current-change="handleCurrentChange"
        @size-change="handleSizeChange" :page-size="pageSize" :total="totalReg" :page-sizes="[5, 10, 15, 20, 25, 30]"
        style="float:right;">
      </el-pagination>
    </el-col>

    <!-- Dialog responsavel por mostrar o preview da DANFE -->
    <el-dialog :show-close="false" width="75%" :visible.sync="dialogPdfVisible" top="2vh" @close="destroyPdfViewer">
      <pdf-viewer v-if="pdfViewerCreated" :pdf-file="pdfBase64" :nfe-chave="nfeChave" @hideDialog="hideDialogPdf">
      </pdf-viewer>
    </el-dialog>

    <!-- Dialog responsavel por mostrar o form de envio de e-mail -->
    <el-dialog v-if="dialogEmailCreated" title="Enviar NF-e por e-mail" :show-close="false"
      :visible.sync="dialogEmailVisible">
      <el-form ref="formEmail" :model="formEmail" label-width="160px" size="mini">
        <el-form-item label="Chave da NF-e">
          <el-input v-model="formEmail.nfeChave" :disabled="true"
            v-mask="'#### #### #### #### #### #### #### #### #### #### ####'"></el-input>
        </el-form-item>

        <el-form-item label="De" prop="emailReply" :rules="[{ required: true, message: 'Informe um endereço de e-mail', trigger: 'blur' },
        { type: 'email', message: 'Informe um endereço de e-mail válido!', trigger: ['blur', 'change'] }]">
          <!-- Foi utilizada string "nops" no auto-complete pois o chrome ignora quando informado "off" -->
          <el-input type="text" v-model="formEmail.emailReply" auto-complete="nops" clearable
            placeholder="Informe seu e-mail para que destinatário possa entrar em contato"></el-input>
        </el-form-item>

        <el-form-item label="Para" prop="emailTo" :rules="[{ required: true, message: 'Informe um endereço de e-mail', trigger: 'blur' },
        { type: 'email', message: 'Informe um endereço de e-mail válido!', trigger: ['blur', 'change'] }]">
          <!-- Foi utilizada string "nops" no auto-complete pois o chrome ignora quando informado "off" -->
          <el-input type="text" v-model="formEmail.emailTo" auto-complete="nops" clearable
            placeholder="Informe o e-mail do destinatário"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="medium" @click="hideDialogEmail">Cancelar</el-button>
        <el-button size="medium" type="primary" :loading=formEmail.sendLoading
          @click="sendEmailNfe('formEmail')">Enviar</el-button>
      </span>
    </el-dialog>
  </section>
</template>

<script>
import { Message } from "element-ui";
import pdfViewer from "./pdf-viewer/pdf-viewer.vue";
import { mask } from "vue-the-mask"; // https://vuejs-tips.github.io/vue-the-mask/
import {
  apiGetEventosNfe,
  apiDownloadXmlNfe,
  apiGetDanfeNfe,
  apiSendEmailNfe
} from "../api/api";

export default {
  name: "table-nfe",
  props: ["listaNfe", "listLoading", "descrEmitDest", "totalReg"],
  components: {
    pdfViewer
  },
  directives: {
    mask
  },
  data () {
    return {
      rowStyle: undefined,
      pdfViewerCreated: true,
      dialogEmailCreated: true,
      eveListLoading: false,
      formRule: {
        xmlLoading: false,
        danfeLoading: false
      },
      pdfBase64: "",
      nfeChave: "",
      nfeSituacao: "N",
      pageNumber: 1,
      pageSize: 10,
      eventosNfe: [],
      dialogPdfVisible: false,
      dialogEmailVisible: false,
      expandRowKeys: [],
      formEmail: {
        emailTo: "",
        emailReply: "",
        nfeChave: "",
        sendLoading: false
      }
    };
  },

  methods: {
    hideDialogPdf () {
      this.dialogPdfVisible = false;
    },
    hideDialogEmail () {
      this.dialogEmailVisible = false;
      this.dialogEmailCreated = false;
    },
    destroyPdfViewer () {
      //Destroi o pdf-viewer
      this.pdfViewerCreated = false;
    },
    formatTipo: (row, column) => {
      return row.tipoDocto == "E"
        ? "Emitida"
        : row.tipoDocto == "R"
          ? "Recebida"
          : " ";
    },
    handleCurrentChange (val) {
      this.pageNumber = val;
      this.$emit("getlistnfe", this.pageNumber, this.pageSize);
    },
    handleSizeChange (val) {
      this.pageSize = val;
      this.$emit("getlistnfe", this.pageNumber, this.pageSize);
    },
    controlExpand (row, expanded) {
      const nfeChave = row.nfeChave;
      const lastNfeChave = this.expandRowKeys[0];
      // disable mutiple row expanded
      this.expandRowKeys = nfeChave === lastNfeChave ? [] : [nfeChave];

      // Passa a situacao da NFe (cancelada ou nao) para poder tratar nos eventos
      this.nfeSituacao = row.nfeSituacao;
      // Somente busca se mudou de linha
      if (this.expandRowKeys[0]) {
        this.eveListLoading = true;
        // Busca dados dos eventos
        let params = {};
        params["cnpj"] = row.cnpj;
        params["nfeChave"] = row.nfeChave;
        this.eventosNfe = [];
        apiGetEventosNfe(params)
          .then(res => {
            this.eventosNfe = res;
            this.eveListLoading = false;
          })
          .catch(error => {
            this.eveListLoading = false;
          });
      }
    },
    downloadXmlNfe (row) {
      this.formRule.xmlLoading = true;
      apiDownloadXmlNfe(row.nfeChave, row.nfeEvento, row.nfeSequencia).then(
        res => {
          const downloadLink = document.createElement('a')
          downloadLink.href = res.url
          downloadLink.click()
          this.formRule.xmlLoading = false;
        }
      );
    },
    downloadDanfeNfe (row) {
      this.formRule.danfeLoading = true;
      this.pdfBase64 = "";
      apiGetDanfeNfe(row.nfeChave)
        .then(res => {
          const reader = new FileReader();
          reader.onloadend = () => {
            this.pdfBase64 = reader.result;
            this.nfeChave = row.nfeChave;
            this.dialogPdfVisible = true;
            this.pdfViewerCreated = true;
          };
          reader.readAsDataURL(res);
          this.formRule.danfeLoading = false;
        })
        .catch(error => {
          Message.error("Não foi possível gerar o DANFE!");
          this.formRule.danfeLoading = false;
        });
    },
    showDialogEmail (row) {
      this.formEmail.nfeChave = row.nfeChave;
      // this.nfeChave = row.nfeChave;
      this.formEmail.emailReply = "";
      this.formEmail.emailTo = "";
      this.dialogEmailCreated = true;
      this.dialogEmailVisible = true;
    },
    sendEmailNfe (formEmail) {
      this.formEmail.sendLoading = true;
      this.$refs[formEmail].validate(valid => {
        if (valid) {
          apiSendEmailNfe(
            this.formEmail.nfeChave.replace(/\s/g, ""), //Remove espacos da chave
            this.formEmail.emailTo,
            this.formEmail.emailReply
          )
            .then(res => {
              this.formEmail.sendLoading = false;
              Message.success(res.message);
              this.hideDialogEmail();
            })
            .catch(error => {
              this.formEmail.sendLoading = false;
              this.hideDialogEmail();
            });
        } else {
          this.formEmail.sendLoading = false;
          return false;
        }
      });
    },
    rowClicked (row) {
      // Expande ao clicar em qualquer lugar da linha
      this.$refs.tableData.toggleRowExpansion(row);
    }
  },
  mounted () {
    // Cria estilo para alterar o cursor do mouse nas linhas da table
    const rowStyle = {}
    rowStyle["cursor"] = 'pointer'
    this.rowStyle = rowStyle
  }
};
</script>

<style scoped></style>


// WEBPACK FOOTER //
// src/components/table-nfe.vue